import { useMemo } from "react"
import { useTheme } from '@mui/material/styles'
import calendarStyles from "../../../styles/EventsCalendarStyles"
import { WeekView } from "@devexpress/dx-react-scheduler-material-ui"

export const tableBodyWeek = (props: any) => {
  const theme = useTheme()
  const classes = useMemo(
    () =>
      calendarStyles(theme, {
        top: 0,
        shadedHeight: 0,
        backgroundColor: '',
        color: ''
      }),
    [theme]
  )
  return <WeekView.TimeTableLayout {...props} sx={classes.monthBody} />
}